export default __webpack_public_path__ + "static/media/enquiry.8f5e5819.jpg";